module.exports = __webpack_public_path__ + "img/robot_mike.e30a91d2.png";